import { City } from "./../_models/city";
import { CityService } from "./../_services/city.service";
import { StateService } from "./../_services/state.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Courier } from "./../_models/courier";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { CourierService } from "../_services/courier.service.js";
import { CountryService } from "../_services/country.service.js";
import { Country } from "../_models/country.js";
import { State } from "../_models/state.js";

@Component({
  selector: "app-city-list-page",
  templateUrl: "./city-list-page.component.html",
  styleUrls: ["./city-list-page.component.scss"],
})
export class CityListPageComponent implements OnInit {
  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    public stateService: StateService,
    public cityService: CityService
  ) { }

  displayedColumns = ["Id", "Name", "CurrencyCode", "formatStateName", "formatActive"];
  dataSource: MatTableDataSource<City>;
  isDataLoaded = false;
  public states: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<City>();
    this.stateService.getStates().subscribe(
      (states) => {
        states.forEach((state) => {
          this.states[state.id] = state.code;
        });
      },
      (err) => {
        this.showErrorMessage("Error retrieving states");
      }
    );
    this.cityService.getCities().subscribe(
      (cities: City[]) => {
        this.dataSource.data = cities.map((city) => {
          city.formatStateName = this.states[city.stateId];
          city.formatActive = city.active ? 'Active' : 'Inactive';
          return city;
        });
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
      },
      (err) => {
        if (err.status == 404) {
          this.dataSource.data = [];
        }
        this.isDataLoaded = true;
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addState() {
    this.router.navigate(["regional", "cities", "add"]);
  }

  viewState(id: number) {
    this.router.navigate(["regional", "cities", id]);
  }
}
